import getStore from 'services/getStore';
import getTopics from 'services/apiHelpers/getTopics';

export default () => {
  const state = getStore().getState();
  const topics = getTopics();
  const currentTopic = topics.find(t => t.id === state.currentTopic);

  return currentTopic || topics[0];
};
